import React, { Fragment } from 'react';
import get from './get';

interface IoInterface {
  id: string;
  value?: object;
}

export default function(props: IoInterface) {
  const { id, value } = props;
  return <Fragment>{value ? get(id, value) : get(id)}</Fragment>;
}
